<!--新建文件夹或修改名称 Sag 2020-4-16-->
<template>
  <ya-dialog-box class="class-space-dialog" :visible.sync="dialogVisible" :width=width multi-layer :fast-close="false" :father-action="dialogBoxAction" top="18%">
    <p slot="title">{{title ? title : '提示'}}</p>
    <div class="its-container">
      <span class="its-title">名称：</span>
      <el-input class="its-file-name" size="small" maxlength="150" v-model="fileName" placeholder="请输入名称"></el-input>
    </div>
    <div v-if="title==='新增文件夹'" class="its-file-tip">最多支持创建3级文件夹哦~</div>
    <template slot="btn">
      <button class="ts-base-btn ts-primary-btn padding" @click="dialogAction('close')" style="margin-right: 10px">取消</button>
      <button class="ts-base-btn ts-primary-btn plain padding" @click="dialogAction('ok')" :disabled="this.fileName==''|| !canClick">确定</button>
    </template>
  </ya-dialog-box>
</template>
<script>
import YaDialogBox from '../../../../components/YaDialogBox'
export default {
  name: 'CreateDialog',
  components: {
    YaDialogBox
  },
  props: {
    width: {
      type: String,
      default: '420px'
    },
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },
    type: {
      type: String,
      default: 'create'
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    canClick: {
      type: Boolean,
      default: true
    },
    fatherAction: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      fileName : '',
      title: ''
    }
  },
  watch: {
    dialogVisible: function () {
      this.fileName = ''
      if(this.dialogVisible) {
        if (this.type === 'create') {
          this.title = '新增文件夹'
        } else {
          this.title = '重命名'
          let it = JSON.parse(JSON.stringify(this.item))
          this.fileName = it.fileName
        }
      }
    }
  },
  methods: {
    dialogAction: function (type) {
      if(type === 'ok') {
        if(!this.fileName || this.fileName.length==0){
          this.$message.warning('请输入名称')
          return
        }
        if(this.fileName.length>150){
          this.$message.warning('名称长度不能超过150')
          return
        }
      }
      if(this.fatherAction) {
        this.fatherAction({type: type, fileName: this.fileName, item: this.item})
      }
    },
    dialogBoxAction: function (data) {
      if(this.fatherAction) {
        this.fatherAction(data)
      }
    },
    handleClose: function () {
      if(this.fatherAction) {
        this.fatherAction({type: 'close'})
      }
    }
  }
}
</script>
<style scoped>
.its-title {
  vertical-align: middle;
}
.its-file-name{
  display: inline-block;
  width: 300px;
}

.its-file-tip {
  color: red;
  font-size: 12px;
  padding-top: 10px;
  margin-left: 43px;
}


</style>
